import { Button } from "primereact/button"
import { useState, useRef, useEffect, useContext } from "react"
import { Toast } from "primereact/toast"
import { LoaderMedium } from "../../../components/Loaders"
import CareerProfileForm from "./CareerProfileForm"
import CareerProfileView from "./CareerProfileView"
import axios from "axios"
import { UserContext } from "../../../context/userContext"
import { employmentApiUrl } from "../../../config/microservicesUrls"
import { useQuery } from "@apollo/client"
import { GET_USER, showError } from "../Utils/Utils"
import styles from "../../../styles/Participant-Employment.module.css"
import NoData from "../Utils/NoData"
import { ReactComponent as TaskCompleteIcon } from "../resources/task_complete.svg"

const Career = ({ updateActiveCareer, inactive, viewMode, closeViewMode }) => {
  const [careerProfile, setCareerProfile] = useState()
  const [showCareerForm, setShowCareerForm] = useState(false)
  const [loading, setLoading] = useState(false)

  const toast = useRef(null)
  const userCtx = useContext(UserContext)

  const referralId = viewMode
    ? viewMode?.referral.id
    : userCtx.currentActiveReferral

  const { refetch } = useQuery(GET_USER, {
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: true,
  })
  const getStaffName = async (staff_id) => {
    if (!staff_id || !userCtx?.session?.user?.organization_id) {
      console.warn(
        "Staff ID or Organization ID are incomplete. Page: Employment career",
      )
      return null
    }

    const res = await refetch({
      staff_id: staff_id,
      organization_id: userCtx.session.user.organization_id,
    })
    const { staff_name_first, staff_name_last } = res.data.user
    return { first: staff_name_first, last: staff_name_last }
  }
  useEffect(() => {
    const getCareerProfile = () => {
      setLoading(true)
      axios
        .get(
          `${employmentApiUrl()}/careerProfile/${referralId}/${
            userCtx.session.user.organization_id
          }/${userCtx.participant_id}`,
          {
            headers: {
              Authorization: `Bearer ${userCtx.tokens.getEmploymentToken()}`,
            },
          },
        )
        .then((response) => {
          if (response.data.id) {
            if (response.data) {
              updateActiveCareer(true)
            }
            setCareerProfile(response.data)
          }
          setLoading(false)
        })
        .catch((response) => {
          const errors = response["response"]["data"]
          setCareerProfile()
          setLoading(false)
          showError(toast, "Not able to get career profile", errors)
        })
    }
    getCareerProfile()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCtx.participant_id])

  const getInitialData = async () => {
    return {
      date_completed: careerProfile?.createdAt,
      performed_by: await getStaffName(careerProfile?.createdBy),
      last_updated: careerProfile?.updatedAt,
      last_updated_by: await getStaffName(careerProfile?.updatedBy),
    }
  }
  const renderNoCareer = () => {
    return (
      <div className={styles.no_record_div}>
        <NoData
          icon={
            <TaskCompleteIcon
              style={{ padding: "8px", width: "100%", height: "100%" }}
            />
          }
        />
        <div style={{ width: "400px" }}>
          <p style={{ fontWeight: "700" }}>
            You haven't created a career profile yet
          </p>
        </div>
        <Button
          className={styles.noDataBtn}
          label="Create career profile"
          onClick={() => {
            setShowCareerForm(true)
          }}
          disabled={inactive || viewMode?.view}
        />
      </div>
    )
  }
  return (
    <>
      <Toast ref={toast} position="top-right" />
      {loading && (
        <div>
          <LoaderMedium />
        </div>
      )}
      {!loading && !careerProfile && !showCareerForm && renderNoCareer()}
      {!loading && showCareerForm && (
        <CareerProfileForm
          closeForm={() => {
            setShowCareerForm(false)
          }}
          update={(data) => {
            setCareerProfile(data)
            setShowCareerForm(false)
            if (data) {
              updateActiveCareer(true)
            }
          }}
          editCareerProfile={careerProfile}
        />
      )}
      {!loading && careerProfile && !showCareerForm && (
        <CareerProfileView
          initialData={getInitialData()}
          data={careerProfile}
          setShowCareerForm={setShowCareerForm}
          inactive={inactive}
          viewMode={viewMode}
          closeViewMode={() => {
            closeViewMode()
          }}
        />
      )}
    </>
  )
}
export default Career
